
 import GenerationGraphTree from '../../Component/TeamOverview/GenerationTree/GenerationTree'
const GenerationTree = () => {
  return (
    <div className='page-body'>
          <GenerationGraphTree />
    </div>

  )
}

export default GenerationTree